/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktaketemplateEditCtrl
 */
angular.module('mercury.modules.stock.stocktake')
.controller('StockStocktaketemplateEditCtrl', ["dialog", "ngToast", "$q", "$scope", "$state", "$stateParams", "StockUnits", "StockItems", "StocktakeTemplates", "title", function(dialog, ngToast, $q, $scope, $state, $stateParams,
  StockUnits, StockItems, StocktakeTemplates, title) {

  title.set('Edit Stocktake Template');

  $scope.groups = [];

  $scope.template = StocktakeTemplates.get($stateParams.id);
  $scope.template.$promise.then(function() {
    angular.forEach($scope.template.lines, function(templateLine) {
      if (!templateLine.stockItemId) {
        $scope.groups.push({
          Header: templateLine,
          Lines: []
        });
      } else {
        $scope.groups[$scope.groups.length - 1].Lines.push(templateLine);
      }
    });
  }, function() {
    $state.go('Stock.StocktakeTemplates');
  });

  $scope.units = StockUnits.getAllActive();
  var items = StockItems.getAllActive();

  $scope.loadingPromise = [
    $scope.units.$promise,
    items.$promise,
    $scope.template.$promise
  ];

  var reindex = function() {
    var lineCount = 0;
    angular.forEach($scope.groups, function(group, groupIndex) {
      group.Header.lineOrder = lineCount++;

      angular.forEach(group.Lines, function(line, lineIndex) {
        $scope.groups[groupIndex].Lines[lineIndex].lineOrder = lineCount++;
      });
    });
  };

  var flattenGroup = function(group) {
    var lines = [group.Header];
    angular.forEach(group.Lines, function(line) {
      lines.push(line);
    });
    return lines;
  };

  var saveLinePositions = function(lines) {
    StocktakeTemplates.updateManyLines($stateParams.id, lines);
  };

  $scope.groupSwap = function(indexOne, indexTwo) {
    var temp = $scope.groups[indexOne];
    $scope.groups[indexOne] = $scope.groups[indexTwo];
    $scope.groups[indexTwo] = temp;

    reindex();

    var flatGroup1 = flattenGroup($scope.groups[indexOne]);
    var flatGroup2 = flattenGroup($scope.groups[indexTwo]);
    saveLinePositions(flatGroup1.concat(flatGroup2));
  };

  $scope.lineSwap = function(group, indexOne, indexTwo) {
    var temp = group.Lines[indexOne];
    group.Lines[indexOne] = group.Lines[indexTwo];
    group.Lines[indexTwo] = temp;

    reindex();

    saveLinePositions([group.Lines[indexOne], group.Lines[indexTwo]]);
  };

  $scope.groupDelete = function(index) {
    $scope.groups[index].deleting = StocktakeTemplates.deleteLine($scope.groups[index].Header);
    $scope.groups[index].deleting.then(function() {
      $scope.groups.splice(index, 1);
      reindex();
    });
  };

  $scope.lineDelete = function(group, index) {
    group.Lines[index].deleting = StocktakeTemplates.deleteLine(group.Lines[index]);
    group.Lines[index].deleting
      .then(function() {
        group.Lines.splice(index, 1);
        reindex();
      });
  };

  $scope.lineUpdateUnit = function(line) {
    StocktakeTemplates.updateLineUnit(line.id, line.unitId);
  };

  $scope.lineUpdateDefaultCount = function(line) {
    StocktakeTemplates.updateLineDefaultCount(line.id, line.defaultCount);
  };

  $scope.itemOptions = function() {
    var existingItems = {};
    angular.forEach($scope.groups, function(group) {
      angular.forEach(group.Lines, function(line) {
        existingItems[line.stockItemId] = true;
      });
    });

    var validItems = [];
    angular.forEach(items, function(item) {
      if (!existingItems[item.id]) {
        validItems.push(item);
      }
    });
    return validItems;
  };

  $scope.groupAddItem = function(group, item) {
    var lastLineOrder = (group.Lines.length > 0) ? group.Lines[group.Lines.length - 1].lineOrder :
      group.Header.lineOrder;

    var newLine = {
      templateId: $scope.template.id,
      stockItemId: item.id,
      stockItemName: item.name,
      unitId: item.countingUnitId,
      unitName: item.countingUnitName,
      lineOrder: parseFloat(lastLineOrder) + 1,
      defaultCount: 0
    };

    StocktakeTemplates.createLine(newLine)
    .then(function(savedLine) {
      group.Lines.push(savedLine);

      reindex();
    });
  };

  $scope.addGroup = function(newHeaderName) {
    if (newHeaderName === '') {
      return;
    }

    //Find what the new headers line order should be.
    var nextLineOrder = 0;
    angular.forEach($scope.groups, function(group) {
      nextLineOrder += group.Lines.length + 1;
    });

    var newHeaderLine = {
      lineOrder: nextLineOrder,
      templateId: $scope.template.id,
      stockItemName: newHeaderName,
      stockItemId: null,
      unitId: null
    };

    StocktakeTemplates.createLine(newHeaderLine)
    .then(function() {
      $scope.groups.push({
        Header: newHeaderLine,
        Lines: []
      });
    });
  };

  $scope.itemGroupKeyPress = function(event, newHeaderName) {
    if (event.keyCode == 13) {
      $scope.addGroup(newHeaderName);
      $scope.newGroupHeader = '';
    }
  };

  $scope.saveTemplate = function() {
    $scope.stocktakeTemplateForm.$setSubmitted();
    if ($scope.stocktakeTemplateForm.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the errors on the template');
      return;
    }

    StocktakeTemplates.update($scope.template)
    .then(function() {
      $state.go('Stock.StocktakeTemplates');
    });
  };

  $scope.deleteTemplate = function() {
    StocktakeTemplates.remove($scope.template)
    .then(function() {
      $state.go('Stock.StocktakeTemplates');
    });
  };
}]);
